import { useEffect, useRef, useState } from "react";
import { Tooltip } from "../tooltip/Tooltip";
import {
  EllipsisContainer,
  Props,
  getTextContent,
  isOverflowing,
} from "./Ellipsis.Parts";

export const Ellipsis = ({
  children,
  disableTooltip = false,
  lines,
  ...props
}: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const textContent = getTextContent(children);

  useEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current && textContent.trim()) {
        setShowTooltip(isOverflowing(containerRef.current, lines));
      } else {
        setShowTooltip(false);
      }
    };

    // Check overflow after initial render
    checkOverflow();

    // Check overflow on window resize
    window.addEventListener("resize", checkOverflow);

    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, [textContent, lines]);

  const ellipsisContent = (
    <EllipsisContainer ref={containerRef} $lines={lines} {...props}>
      {children}
    </EllipsisContainer>
  );

  // Only show tooltip if not disabled, has text content, and is actually overflowing
  if (disableTooltip || !textContent.trim() || !showTooltip) {
    return ellipsisContent;
  }

  return <Tooltip tip={textContent}>{ellipsisContent}</Tooltip>;
};
